import PropTypes from 'prop-types';

import { parseAndCleanHtmlToReact } from 'helpers/HtmlHelpers';

import styles from 'styles/components/landing/agreement.scss';

const Agreement = ({ slotDetails }, { testId }) => {
  const { agreement, style, monetateId } = slotDetails;
  // sanitize html returned from Mafia/Gateway Content Symphony API
  const contentComponent = parseAndCleanHtmlToReact(agreement);
  return (
    <div className={styles.content} data-test-id={testId('agreement')} data-monetate-id={monetateId}>
      <div className={style}>
        {contentComponent}
      </div>
    </div>
  );
};

Agreement.contextTypes = {
  testId: PropTypes.func
};

export default Agreement;
